import { useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { UserContext } from "./context/UserContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import EventManagerRoutes from "./routes/EventManagerRoutes";
import axios from "axios";
import { Helmet } from "react-helmet";

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

Axios.interceptors.request.use(
  (config) => {
    document.body.classList.add("loading-indicator");
    const token = localStorage.getItem("loginToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

Axios.interceptors.response.use(
  function (response) {
    document.body.classList.remove("loading-indicator");
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const App = () => {
  const { user, isLoading } = useContext(UserContext);

  if (isLoading) return <></>;

  return (
    <>
      <div className="app">
        <Helmet>
          <title>Admin - JBEvent</title>
        </Helmet>
        <BrowserRouter>
          <Routes>
            {user && (
              <>
                <Route path="/" element={<Dashboard />} />
                <Route
                  path="/event-manager/*"
                  element={<EventManagerRoutes />}
                />
                <Route path="/sign-up" element={<Register />} />
              </>
            )}
            {!user && <Route path="/login" element={<Login />} />}
            <Route path="*" element={<Navigate to={user ? "/" : "/login"} />} />
          </Routes>
        </BrowserRouter>
      </div>
    </>
  );
};

export default App;
